import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const createCompany = createAsyncThunk(
  "createCompany",
  async ({ data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.post(
      `company/create`,
      data,
      config
    );

    form.resetFields();
    message.success("Company successfully created!");
    history("/app/organization/company");
    return response.data;
  }
);

const companyCreateSlice = createSlice({
  name: "companyCreate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(createCompany.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(createCompany.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(createCompany.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default companyCreateSlice.reducer;